const targetsModule = angular.module('com.comtrade.azureCloud.backup.targets', []);

targetsModule.component('targets', require('./targets.component'));
targetsModule.component('targetAddEditDialog', require('./dialogs/targetAddEditDialog/targetAddEditDialog.component'));
targetsModule.service('targetsPersistence', require('./targets.persistence.service.js'));

module.exports = targetsModule;



// WEBPACK FOOTER //
// ./src/azurebackup/views/targets/targets.module.js